import Cookies from 'js-cookie'
import Component from '../core/Component'



export default class LangSwitch extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            opener: null,
            closers: [],
            dropdown: null
        }

        this.timer = null
        this.isAttached = false
    }

    prepare() {
        this.ref.closers.forEach(closer => closer.addEventListener('click', this.handleCloserClick))
        this.ref.opener.addEventListener('click', this.handleOpenerClick)

        //hlavni desktopovej langswitch zobrazit jako modal, pokud je uzivatel na blby verzi fade (CZ vs SK)
        if (this.element.classList.contains('LangSwitch--main')) {
            this.ref.opener.addEventListener('mouseenter', this.handleMouseEnter)
            this.ref.opener.addEventListener('mouseleave', this.handleMouseLeave)
            this.ref.dropdown.addEventListener('mouseenter', this.handleMouseEnter)
            this.ref.dropdown.addEventListener('mouseleave', this.handleMouseLeave)

            const wasClosedRecently = Cookies.get('langswitch-closed') === 'true'
            if (!wasClosedRecently) {
                this.getLang().then(lang => {
                    const documentLang = document.documentElement.lang
                    if ((lang === 'cs' && documentLang === 'sk') || (lang === 'sk' && documentLang === 'cs')) {
                        this.openAsModal()
                    }
                })
            }
        }
    }

    handleOpenerClick = () => {
        this.attach()
    }

    handleCloserClick = () => {
        if (this.element.classList.contains('LangSwitch--modal')) {
            this.element.classList.remove('is-active')
            this.element.offsetWidth
            Cookies.set('langswitch-closed', 'true')
            this.element.className = this.originalClassName
        }

        this.detach()
    }

    handleMouseEnter = () => {
        clearTimeout(this.timer)

        this.attach()
    }

    handleMouseLeave = () => {
        clearTimeout(this.timer)
        this.timer = setTimeout(()=> {
            this.detach()
        },100)
    }

    attach() {
        clearTimeout(this.timer)

        if (this.isAttached) {
            return
        }

        this.element.classList.add('is-active')
        this.isAttached = true
    }

    detach() {
        if (!this.isAttached) {
            return
        }

        this.element.classList.remove('is-active')
        this.isAttached = false
    }

    openAsModal() {
        this.detach()
        this.originalClassName = this.element.className
        this.element.className = 'LangSwitch LangSwitch--modal'
        this.attach()
    }

    async getLang() {
        let lang = ''

        lang = navigator.language.split('-')[0]
        if (/^cs|sk\b/.test()) {
            return Promise.resolve(lang)
        }

        lang = Cookies.get('langswitch-lang')
        if (lang) {
            return Promise.resolve(lang)
        }
        try {
            const countryToLang = {
                'CZ': 'cs',
                'SK': 'sk'
            }
            const response = await fetch("https://ipinfo.io/json")
            const data = await response.json()
            lang = countryToLang[data.country]

            if (lang) {
                Cookies.set('langswitch-lang', lang, {
                    expires: 1
                })
            }
        } catch (err) {
            console.error(err)
        }

        return lang
    }

}